import {h, Fragment} from "preact"
import { useActions, useProductFilters } from '@nosto/preact'
import { useState, useEffect } from 'preact/hooks'
import { cleanValue } from "../helpers"

export default ({ facet, index, setShowFilters, modifiedFilters, setModifiedFilters, filterFacet, setFilterFacet, clickedFacet, setClickedFacet }) => {
    const { name, data } = facet;

    const { toggleProductFilter } = useActions()
    const { filters, removeAll } = useProductFilters()

    const [active, setActive] = useState(false);

    const isAge = name.toLowerCase() === "age";
    const isColor = name.toLowerCase() === "color";
    const isAvailability = name.toLowerCase() === "availability";

    const shouldOpenAgeAccordion = false;

    useEffect(() => {
        if (clickedFacet) {
            setActive(facet.id === clickedFacet.id);
            setClickedFacet(null);
        }
    })

    useEffect(() => {
        setModifiedFilters([]);
        setModifiedFilters(filters.map((f) => (
            {
                facet: f.field,
                value: f.value,
                selected: true,
            }
        )));
    }, [filters.length])

    const handleRemoveFacetFilters = (e) => {
        e.preventDefault();
        if (modifiedFilters.filter(filter => filter.facet === facet.field).length > 0) {
            modifiedFilters.filter(filter => filter.facet === facet.field).forEach((filter) => {
                toggleProductFilter(filter.facet, filter.value, false);
            });
        }
        setShowFilters(false);
    }

    return (
        <li class={`${shouldOpenAgeAccordion ? "ns-sidebar-dropdown age ns-active" : (active ? 'ns-sidebar-dropdown ns-active' : 'ns-sidebar-dropdown')}`}>
            <button
                class="notabutton ns-relative ns-w-100 ns-border-box ns-text-undecorated ns-p-4 ns-facet-name"
                data-nosto-element="facet"
                aria-label={`${shouldOpenAgeAccordion ? `Collapse filter: ${name}` : (active ? `Collapse filter: ${name}` : `Expand filter: ${name}`)}`}
                aria-expanded={`${shouldOpenAgeAccordion ? "true" : (active ? "true" : "false")}`}
                aria-controls={`FacetPanel-${facet.field}`}
                onClick={() => {
                    setActive(!active)
                    if (shouldOpenAgeAccordion) {
                        jQuery(".ns-sidebar-dropdown.age").toggleClass("ns-active")
                    }
                }}
            >
                <h2 class="filter-group__heading__text body-style">
                    {name}
                </h2>
                <span class="ns-icon ns-icon-arrow">
                    <svg class="svg-icon" viewBox="0 0 20 20">
                        <path fill="none" d="M1.729,9.212h14.656l-4.184-4.184c-0.307-0.306-0.307-0.801,0-1.107c0.305-0.306,0.801-0.306,1.106,0
                    l5.481,5.482c0.018,0.014,0.037,0.019,0.053,0.034c0.181,0.181,0.242,0.425,0.209,0.66c-0.004,0.038-0.012,0.071-0.021,0.109
                    c-0.028,0.098-0.075,0.188-0.143,0.271c-0.021,0.026-0.021,0.061-0.045,0.085c-0.015,0.016-0.034,0.02-0.051,0.033l-5.483,5.483
                    c-0.306,0.307-0.802,0.307-1.106,0c-0.307-0.305-0.307-0.801,0-1.105l4.184-4.185H1.729c-0.436,0-0.788-0.353-0.788-0.788
                    S1.293,9.212,1.729,9.212z"></path>
                    </svg>
                </span>
            </button>
            <div class="ns-sidebar-submenu" id={`FacetPanel-${facet.field}`} hidden={!active}>
                <form class="ns-list-unstyled ns-px-4 ns-pb-4 ns-m-0">
                    <fieldset>
                        <legend class="visually-hidden">
                            Filter by: {name}
                        </legend>
                        
                        {data?.map((value, index) => {
                            return (
                                <div class="ns-d-flex ns-justify-content-between ns-align-items-center ns-font-3 ns-mt-2 ns-mb-2" data-nosto-element="facet-setting">
                                    <input
                                        type="checkbox"
                                        id={`${value.value.replaceAll(" ","_")}-${index}`}
                                        class="ns-checkbox-input"
                                        aria-live="polite"
                                        checked={modifiedFilters.some(filter => filter.facet === facet.field && filter.value === value.value && filter.selected)}
                                        onChange={(e) => {
                                            e.preventDefault()
                                            setFilterFacet(facet);

                                            const valueIndex = modifiedFilters.findIndex(filter => filter.facet === facet.field && filter.value === value.value)


                                            if (valueIndex === -1) {
                                                const clickedFilter = { facet: facet.field, value: value.value, selected: !value.selected }
                                                setModifiedFilters(prevFilters => [...prevFilters, clickedFilter])

                                            } else {

                                                const newlyModifiedFilters = [...modifiedFilters];
                                                modifiedFilters[valueIndex].selected = !modifiedFilters[valueIndex].selected;
                                                setModifiedFilters(newlyModifiedFilters);

                                            }
                                        }}
                                    />
                                    
                                    <label class="ns-checkbox filter-group__item__text" for={`${value.value.replaceAll(" ","_")}-${index}`} aria-label={`Filter by ${name}, option: ${value.value}`}>
                                        {cleanValue(value.value)}
                                        <span class="ns-checkmark"></span>
                                    </label>
                                </div>
                            )}
                        )}
                    </fieldset>
                </form>
            </div>
        </li>
    )
}
